<template>
    <div class="navbar-content grid grid__base">
        <div class="navbar-content--container grid--container">
            <div class="navbar-content--row grid--row">
                <a href="/" class="u-reset grid--col navbar-content--brand-link">
                    <img :alt="brandLogoAlt" :src="'img/im-logo-desktop-black.svg'|staticPath">
                </a>
                <ul class="navbar-content--list u-reset grid--col">
                    <li class="navbar-content--list-item" v-for="(item, idx) in items" :key="idx">
                        <navbar-item v-bind="item"/>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

    import NavbarItem from 'framework/components/navigation/navbar/navbar-item/navbar-item';

    export default {
        components: { NavbarItem },
        props: {
            /** @type {INavigationEntry[]} */
            items: {
                type: Array,
                required: true,
            },

            brandLogoAlt: {
                type: String,
                required: true,
            },
        },
    };
</script>
